import { Theme } from '@mui/material/styles';
import { U21Palette } from 'vendor/material-minimal/palette';
import { U21CustomShadows } from 'vendor/material-minimal/shadows';
import { U21Shape } from 'vendor/material-minimal/shape';
import { U21Typography } from 'vendor/material-minimal/typography';

export enum U21Themes {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface U21Theme
  extends Omit<Theme, 'palette' | 'shape' | 'typography'> {
  customShadows: U21CustomShadows;
  palette: U21Palette;
  shape: U21Shape;
  typography: U21Typography;
}

declare module '@mui/private-theming/defaultTheme' {
  interface DefaultTheme extends U21Theme {}
}
